import { createAction, props } from '@ngrx/store';
import { TourType } from '../../data/tour-config';
import { TourProgress, TourProgressStatus } from '../../models/tour-progress';

export const loadTourProgress = createAction('[Tour Progress] Load Tour Progress');

export const loadTourProgressSuccess = createAction(
  '[Tour Progress] Load Tour Progress Success',
  props<{ progress: TourProgress[] }>()
);

export const loadTourProgressFailure = createAction(
  '[Tour Progress] Load Tour Progress Failure',
  props<{ error: unknown }>()
);

export const upsertTourProgress = createAction(
  '[Tour Progress] Upsert Tour Progress',
  props<{ tourType: TourType; seenVersion: number; status: TourProgressStatus }>()
);

export const upsertTourProgressSuccess = createAction(
  '[Tour Progress] Upsert Tour Progress Success',
  props<{ progress: TourProgress }>()
);

export const upsertTourProgressFailure = createAction(
  '[Tour Progress] Upsert Tour Progress Failure',
  props<{ error: unknown; tourType: TourType }>()
);
